import { getNewbuildingChatContacts } from '@cian/newbuilding-chat-component';

import { getBuilders } from './getBuilders';
import { getSellers } from './getSellers';
import { IAppState } from '../../common/state';

export const getBuilderChatEnabled = (state: IAppState): boolean => {
  const builders = getBuilders(state);
  const sellers = getSellers(state);
  const chatContacts = getNewbuildingChatContacts(builders ?? [], sellers ?? []);

  return chatContacts.length > 0;
};
